// extracted by mini-css-extract-plugin
module.exports = {"input-container":"J0T2z","input-suffix":"VGB-8","numeric":"RU994","input":"uqR38"};